import { render, staticRenderFns } from "./cancellation-and-amendment-policy.vue?vue&type=template&id=8bf433e8&scoped=true"
import script from "./cancellation-and-amendment-policy.vue?vue&type=script&lang=ts"
export * from "./cancellation-and-amendment-policy.vue?vue&type=script&lang=ts"
import style0 from "./cancellation-and-amendment-policy.vue?vue&type=style&index=0&id=8bf433e8&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bf433e8",
  null
  
)

export default component.exports